import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Partners from "./views/Partners.vue";
import Users from "./views/Users.vue";
import User from "./views/User.vue";
import Settings from "./views/Settings.vue";
import Log from "./views/Log.vue";
import Partner from "./views/Partner.vue";
import UserSettings from "./views/UserSettings.vue";
import Goods from "./views/Goods.vue";
import Instructions from "./views/Instructions.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/demo/:token?",
      name: "demo",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Demo.vue")
    },
    {
      path: "/api-manual",
      name: "instructions",
      component: Instructions
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        layout: "login-layout"
      }
    },
    {
      path: "/partners",
      name: "partners",
      component: Partners
    },
    {
      path: "/partners/new",
      name: "partneradd",
      component: Partner
    },
    {
      path: "/partners/:id",
      name: "partner",
      component: Partner
    },
    {
      path: "/partners/:id/goods",
      name: "goods",
      component: Goods
    },
    {
      path: "/users",
      name: "users",
      component: Users
    },
    {
      path: "/users/new",
      name: "useradd",
      component: User
    },
    {
      path: "/users/:id",
      name: "user",
      component: User
    },
    {
      path: "/log",
      name: "log",
      component: Log
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "/user-settings",
      name: "user-settings",
      component: UserSettings
    }
  ]
});
